import type { FC } from 'react';
import type { IconProps } from './types';

const AlertSolid: FC<IconProps> = ({ color = 'currentColor', size = 24, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      color={color}
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9981 21.75C16.253 21.75 18.0331 21.75 19.3516 21.5537C20.6903 21.3543 21.7764 20.9217 22.376 19.8633C22.975 18.8058 22.79 17.6499 22.2764 16.3945C21.7718 15.1614 20.8655 13.6328 19.7168 11.6963L19.669 11.6162L17.7442 8.37109L17.6983 8.29297C16.5956 6.4338 15.7229 4.96328 14.9112 3.96484C14.0829 2.94615 13.1845 2.25 12 2.25C10.8156 2.25004 9.91717 2.94615 9.08889 3.96484C8.27717 4.96323 7.40537 6.43396 6.30276 8.29297L6.25588 8.37109L4.33108 11.6162L4.28323 11.6963C3.13458 13.6328 2.22822 15.1614 1.72366 16.3945C1.21006 17.6498 1.0251 18.8058 1.62405 19.8633C2.22363 20.9217 3.30976 21.3543 4.64846 21.5537C5.96691 21.75 7.74701 21.75 10.002 21.75L13.9981 21.75ZM12 14C11.4477 14 11 13.5523 11 13V9C11 8.44771 11.4477 8 12 8C12.5523 8 13 8.44771 13 9V13C13 13.5523 12.5523 14 12 14ZM12 17.75C11.4477 17.75 11 17.3023 11 16.75C11 16.1977 11.4477 15.75 12 15.75C12.5523 15.75 13 16.1977 13 16.75C13 17.3023 12.5523 17.75 12 17.75Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default AlertSolid;
